/* ============================================================
   REUSABLE PRODUCT CARD — product-card.js
   Self-contained behaviour: badge typing, hover ATC overlay,
   variant selection, qty selector, add-to-cart with cart-drawer
   open. Quick-view button only EMITS an event — host section
   listens and shows its own modal.
   ============================================================ */
(function () {
  'use strict';

  if (window.__pcCardInit) return;
  window.__pcCardInit = true;

  /* ── Helpers ──────────────────────────────────────────── */
  var CART_SVG  = '<svg viewBox="0 0 24 24" style="width:15px;height:15px;stroke:#fff;fill:none;stroke-width:2;flex-shrink:0;pointer-events:none"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" style="width:15px;height:15px;stroke:#fff;fill:none;stroke-width:2.5;flex-shrink:0;pointer-events:none"><polyline points="20 6 9 17 4 12"/></svg>';
  function spinSVG() {
    return '<svg viewBox="0 0 24 24" style="width:15px;height:15px;stroke:#fff;fill:none;stroke-width:2;flex-shrink:0;pointer-events:none;animation:pcOvSpin 0.75s linear infinite"><circle cx="12" cy="12" r="10" stroke-dasharray="32" stroke-dashoffset="10"/></svg>';
  }

  var productCache = {};

  /* ── Cart helpers ─────────────────────────────────────── */
  function getCartSectionIds() {
    var ids = [];
    ['cart-drawer', 'cart-notification', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'].forEach(function (id) {
      if (document.getElementById(id)) ids.push(id);
    });
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && /cart|header/i.test(sid) && ids.indexOf(sid) === -1) ids.push(sid);
    });
    document.querySelectorAll('[id]').forEach(function (el) {
      if (/cart|header/i.test(el.id) && ids.indexOf(el.id) === -1) ids.push(el.id);
    });
    return ids.slice(0, 6);
  }

  function applySectionRenders(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (sectionId) {
      var html = sections[sectionId];
      if (!html) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var target = document.getElementById(sectionId);
      if (target) {
        var fresh = doc.querySelector('#' + sectionId);
        target.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
      }
    });
  }

  function openCartDrawer() {
    ['cart:open', 'theme:cart:open', 'cart:refresh', 'cart-notification:open'].forEach(function (ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
    window.dispatchEvent(new CustomEvent('cart:open'));
    var triggers = [
      '[data-cart-drawer-trigger]', '[data-cart-toggle]', '[data-cart-open]',
      '.js-cart-link', '.cart-drawer__toggle', '.header__icon--cart',
      '.header-cart', '.cart-icon-wrapper a', 'a[href="/cart"]',
      '[aria-label="Cart"]', '[aria-label="Open cart"]', '[aria-label*="cart" i]'
    ];
    for (var i = 0; i < triggers.length; i++) {
      var candidates = document.querySelectorAll(triggers[i]);
      for (var j = 0; j < candidates.length; j++) {
        var el = candidates[j];
        if (el.closest('.pc-card')) continue;
        el.click();
        return;
      }
    }
  }

  function fetchAddToCart(variantId, qty, onSuccess, onError) {
    var sectionIds = getCartSectionIds();
    var body = { id: Number(variantId), quantity: Number(qty) };
    if (sectionIds.length) body.sections = sectionIds;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.');
        if (res.data && res.data.sections) applySectionRenders(res.data.sections);
        ['cart:refresh', 'cart:updated', 'theme:cart:open', 'on:cart:add'].forEach(function (e) {
          document.dispatchEvent(new CustomEvent(e, { bubbles: true }));
        });
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        if (onSuccess) onSuccess(res.data);
      })
      .catch(function (err) { if (onError) onError(err); });
  }

  function refreshCartSections(onDone) {
    var sectionIds = getCartSectionIds();
    if (!sectionIds.length) { if (onDone) onDone(); return; }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: {}, sections: sectionIds })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections) applySectionRenders(data.sections);
        ['cart:refresh', 'cart:updated'].forEach(function (e) {
          document.dispatchEvent(new CustomEvent(e, { bubbles: true }));
        });
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        if (onDone) onDone();
      })
      .catch(function () { if (onDone) onDone(); });
  }

  function addToCartAndOpenDrawer(variantId, qty, atcBtn, ov) {
    var nativeForm = document.querySelector('.js-product-form') || document.querySelector('form[action*="/cart/add"]');
    var nativeBtn = nativeForm ? nativeForm.querySelector('button[name="add"]') : null;
    if (nativeForm && nativeBtn) {
      var vi = nativeForm.querySelector('input[name="id"]');
      if (vi) { vi.disabled = false; vi.value = String(variantId); }
      var qi = nativeForm.querySelector('input[name="quantity"]');
      if (qi) qi.value = String(qty);
      nativeBtn.click();
      atcBtn.innerHTML = CHECK_SVG + ' Added!';
      setTimeout(function () {
        refreshCartSections(function () { openCartDrawer(); });
      }, 500);
      setTimeout(function () {
        atcBtn.disabled = false;
        atcBtn.innerHTML = CART_SVG + ' Add To Cart';
        if (ov) { ov.classList.remove('is-open'); var c = ov.closest('.pc-card'); if (c) c.classList.remove('pc-ov-active'); }
      }, 1800);
    } else {
      atcBtn.disabled = true;
      atcBtn.innerHTML = spinSVG() + ' Adding…';
      fetchAddToCart(variantId, qty,
        function () {
          atcBtn.innerHTML = CHECK_SVG + ' Added!';
          openCartDrawer();
          setTimeout(function () {
            atcBtn.disabled = false;
            atcBtn.innerHTML = CART_SVG + ' Add To Cart';
            if (ov) { ov.classList.remove('is-open'); var c = ov.closest('.pc-card'); if (c) c.classList.remove('pc-ov-active'); }
          }, 1800);
        },
        function (err) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = CART_SVG + ' Add To Cart';
          alert(err && err.message ? err.message : 'Could not add to cart.');
        }
      );
    }
  }

  /* ── Badge typing effect ──────────────────────────────── */
  function initBadgeTyping(card) {
    var BS = parseInt(card.dataset.badgeTypingSpeed, 10) || 70;
    var BD = Math.max(30, Math.floor(BS / 2));
    var idx = Array.prototype.indexOf.call(card.parentNode ? card.parentNode.children : [card], card);

    card.querySelectorAll('.pc-badge-typing').forEach(function (el) {
      var txt = el.dataset.badgeText || '';
      if (!txt) return;
      el.textContent = '';
      setTimeout(function () {
        var i = 0, del = false;
        (function tick() {
          if (!del) {
            el.textContent = txt.slice(0, ++i);
            if (i >= txt.length) { del = true; setTimeout(tick, 1800); }
            else setTimeout(tick, BS);
          } else {
            el.textContent = txt.slice(0, --i);
            if (i <= 0) { del = false; setTimeout(tick, 400); }
            else setTimeout(tick, BD);
          }
        })();
      }, 400 + Math.max(0, idx) * 250);
    });
  }

  /* ── Overlay ──────────────────────────────────────────── */
  function closeAllOverlays(except) {
    document.querySelectorAll('.pc-card-overlay.is-open').forEach(function (ov) {
      if (ov !== except) {
        ov.classList.remove('is-open');
        var c = ov.closest('.pc-card');
        if (c) c.classList.remove('pc-ov-active');
      }
    });
  }

  function buildOverlayHTML(product, card) {
    var variants = product.variants || [], options = product.options || [];
    var sel = variants.find(function (v) { return v.available; }) || variants[0];
    card._ovVariant = sel;
    card._ovQty = 1;
    var hasOptions = options.length > 0 && !(options.length === 1 && (typeof options[0] === 'object' ? options[0].name : options[0]) === 'Title');
    var sizesHTML = '';
    if (hasOptions) {
      var optName = typeof options[0] === 'object' ? options[0].name : options[0];
      var vals = Array.from(new Set(variants.map(function (v) { return v.option1; })));
      sizesHTML = '<p class="pc-ov-label">' + optName + '</p><div class="pc-ov-sizes">';
      vals.forEach(function (val) {
        var avail = variants.some(function (v) { return v.option1 === val && v.available; });
        var isOn = sel && sel.option1 === val ? ' is-on' : '';
        sizesHTML += '<button class="pc-ov-size-btn' + isOn + (avail ? '' : ' is-na') + '" data-val="' + String(val).replace(/"/g, '&quot;') + '" type="button">' + val + '</button>';
      });
      sizesHTML += '</div>';
    }
    var maxQty = sel && sel.inventory_quantity > 0 ? sel.inventory_quantity : 999;
    var avail = sel ? sel.available : false;
    return '<div class="pc-ov-glass">'
      + '<button class="pc-ov-close" data-pc-ov-close type="button" aria-label="Close">&times;</button>'
      + sizesHTML
      + '<div class="pc-ov-qty-row"><span class="pc-ov-qty-label">Quantity</span>'
      + '<div class="pc-ov-qty-selector">'
      + '<button class="pc-ov-qty-btn" data-pc-ov-minus type="button">&#8722;</button>'
      + '<input class="pc-ov-qty-val" data-pc-ov-qty type="number" value="1" min="1" max="' + maxQty + '" readonly>'
      + '<button class="pc-ov-qty-btn" data-pc-ov-plus type="button">&#43;</button>'
      + '</div></div></div>'
      + '<button class="pc-ov-atc-btn" data-pc-ov-atc type="button"' + (avail ? '' : ' disabled') + '>'
      + CART_SVG + (avail ? 'Add To Cart' : 'Sold Out') + '</button>';
  }

  function refreshATCState(card) {
    var overlay = card.querySelector('[data-pc-overlay]');
    if (!overlay) return;
    var btn = overlay.querySelector('[data-pc-ov-atc]'), inp = overlay.querySelector('[data-pc-ov-qty]'), v = card._ovVariant;
    if (!btn) return;
    var avail = v ? v.available : false;
    btn.disabled = !avail;
    btn.innerHTML = CART_SVG + (avail ? 'Add To Cart' : 'Sold Out');
    if (inp && v) {
      var m = v.inventory_quantity > 0 ? v.inventory_quantity : 999;
      inp.max = String(m);
      if (parseInt(inp.value) > m) { inp.value = String(m); card._ovQty = m; }
    }
  }

  function openCardOverlay(card) {
    var overlay = card.querySelector('[data-pc-overlay]');
    if (!overlay) return;
    closeAllOverlays(overlay);
    var handle = card.dataset.handle;
    if (!handle) return;
    var inner = overlay.querySelector('[data-pc-ov-inner]');
    if (!inner) return;
    overlay.classList.add('is-open');
    card.classList.add('pc-ov-active');
    if (productCache[handle]) { inner.innerHTML = buildOverlayHTML(productCache[handle], card); return; }
    inner.innerHTML = '<div style="font-size:12px;color:#888;text-align:center;padding:14px 0;">Loading…</div>';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        productCache[handle] = p;
        if (overlay.classList.contains('is-open')) inner.innerHTML = buildOverlayHTML(p, card);
      })
      .catch(function () {
        if (overlay.classList.contains('is-open')) inner.innerHTML = '<div style="font-size:11px;color:#c00;text-align:center;padding:10px 0;">Could not load.</div>';
      });
  }

  /* ── Global click delegation ──────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* ATC trigger inside a card */
    var atcTrigger = t.closest('.pc-atc-btn');
    if (atcTrigger) {
      e.preventDefault(); e.stopPropagation();
      var card = atcTrigger.closest('.pc-card');
      if (!card) return;
      var ov = card.querySelector('[data-pc-overlay]');
      if (ov && ov.classList.contains('is-open')) { ov.classList.remove('is-open'); card.classList.remove('pc-ov-active'); }
      else openCardOverlay(card);
      return;
    }

    /* Quick-view button — just emit; host section handles modal */
    var qvTrigger = t.closest('[data-pc-quickview]');
    if (qvTrigger) {
      e.preventDefault(); e.stopPropagation();
      var handle = qvTrigger.dataset.handle;
      if (handle) {
        document.dispatchEvent(new CustomEvent('pc:quickview', {
          bubbles: true,
          detail: { handle: handle, trigger: qvTrigger }
        }));
      }
      return;
    }

    /* Overlay close */
    var closeBtn = t.closest('[data-pc-ov-close]');
    if (closeBtn) {
      e.preventDefault(); e.stopPropagation();
      var ovc = closeBtn.closest('[data-pc-overlay]');
      if (ovc) { ovc.classList.remove('is-open'); var cc = ovc.closest('.pc-card'); if (cc) cc.classList.remove('pc-ov-active'); }
      return;
    }

    /* Size button */
    var sizeBtn = t.closest('.pc-ov-size-btn');
    if (sizeBtn && !sizeBtn.classList.contains('is-na')) {
      e.preventDefault(); e.stopPropagation();
      var cardS = sizeBtn.closest('.pc-card');
      if (!cardS) return;
      var pS = productCache[cardS.dataset.handle];
      if (!pS) return;
      sizeBtn.closest('.pc-ov-sizes').querySelectorAll('.pc-ov-size-btn').forEach(function (b) { b.classList.remove('is-on'); });
      sizeBtn.classList.add('is-on');
      var m = pS.variants.find(function (v) { return v.option1 === sizeBtn.dataset.val; });
      if (m) { cardS._ovVariant = m; refreshATCState(cardS); }
      return;
    }

    /* Qty minus */
    var minusBtn = t.closest('[data-pc-ov-minus]');
    if (minusBtn) {
      e.preventDefault(); e.stopPropagation();
      var cardM = minusBtn.closest('.pc-card');
      if (!cardM) return;
      var inpM = cardM.querySelector('[data-pc-ov-qty]');
      var valM = Math.max(1, (cardM._ovQty || 1) - 1);
      cardM._ovQty = valM;
      if (inpM) inpM.value = String(valM);
      return;
    }

    /* Qty plus */
    var plusBtn = t.closest('[data-pc-ov-plus]');
    if (plusBtn) {
      e.preventDefault(); e.stopPropagation();
      var cardP = plusBtn.closest('.pc-card');
      if (!cardP) return;
      var vP = cardP._ovVariant;
      var maxP = vP && vP.inventory_quantity > 0 ? vP.inventory_quantity : 999;
      var inpP = cardP.querySelector('[data-pc-ov-qty]');
      var valP = Math.min(maxP, (cardP._ovQty || 1) + 1);
      cardP._ovQty = valP;
      if (inpP) inpP.value = String(valP);
      return;
    }

    /* Overlay ATC */
    var atcBtn = t.closest('[data-pc-ov-atc]');
    if (atcBtn) {
      e.preventDefault(); e.stopPropagation();
      var cardA = atcBtn.closest('.pc-card');
      if (!cardA) return;
      var vA = cardA._ovVariant;
      if (!vA || !vA.available || atcBtn.disabled) return;
      var qtyA = cardA._ovQty || 1;
      var ovA = cardA.querySelector('[data-pc-overlay]');
      atcBtn.disabled = true;
      atcBtn.innerHTML = spinSVG() + ' Adding…';
      addToCartAndOpenDrawer(vA.id, qtyA, atcBtn, ovA);
      return;
    }

    /* Click outside an open overlay closes it */
    if (!t.closest('.pc-card-overlay') && !t.closest('.pc-atc-btn')) closeAllOverlays(null);
  });

  /* ── Init each card (badge typing + observe future cards) ─ */
  function initCard(card) {
    if (card._pcInit) return;
    card._pcInit = true;
    initBadgeTyping(card);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pc-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Re-init cards injected later (e.g. infinite-scroll clones) */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-pc-card]')) initCard(n);
          if (n.querySelectorAll) n.querySelectorAll('[data-pc-card]').forEach(initCard);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* Public hook for external code */
  window.ProductCard = {
    initAll: initAll,
    openOverlay: openCardOverlay,
    closeOverlays: closeAllOverlays
  };
})();